import $api from "@/shared/http";
import { toApiError } from "@/shared/http/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { DealerReportsResponse } from "../../model/types";

export const fetchDealerRemainsReports = createAsyncThunk<
  DealerReportsResponse,
  void,
  { rejectValue: string }
>("dealer/fetchDealerRemainsReports", async (_, { rejectWithValue }) => {
  try {
    const response = await $api.get<DealerReportsResponse>(
      "/dealerremainsreports/weekly-summary/remains",
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

export const fetchDealerSalesReports = createAsyncThunk<
  DealerReportsResponse,
  void,
  { rejectValue: string }
>("dealer/fetchDealerSalesReports", async (_, { rejectWithValue }) => {
  try {
    const response = await $api.get<DealerReportsResponse>(
      "/dealerremainsreports/weekly-summary/sales",
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

export const generateRemainReport = createAsyncThunk<
  DealerReportsResponse,
  void,
  { rejectValue: string }
>("dealer/generateRemainReport", async (_, { rejectWithValue }) => {
  try {
    const response = await $api.post<DealerReportsResponse>(
      "/dealerremainsreports/dealer-remains/generate",
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});

export const generateSalesReport = createAsyncThunk<
  DealerReportsResponse,
  void,
  { rejectValue: string }
>("dealer/generateSalesReport", async (_, { rejectWithValue }) => {
  try {
    const response = await $api.post<DealerReportsResponse>(
      "/dealerremainsreports/dealer-sales/generate",
    );
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});
